import { useBaseComponent } from 'basics/component/base-component';
import { ReactElement } from 'react';
// import { TaskAttachmentsFileUpload } from './FileUpload/TaskAttachmentsFileUpload';
import { TaskAttachmentsItem } from './Item/TaskAttachmentsItem';
// import { TaskAttachmentsModal } from './Modal/TaskAttachmentsModal';
import { TaskAttachmentsList } from './TaskAttachments-style';
import {
  ITaskAttachmentsProps,
  ITaskAttachmentsState,
} from './TaskAttachments-type';
import { ITaskDocumentView } from 'store/tasks/tasksType';
import { TaskAttachmentsModal } from './Modal/TaskAttachmentsModal';
import i18n from '../../../../i18n';

export const TaskAttachments = (props: ITaskAttachmentsProps): ReactElement => {
  const { setState, state } = useBaseComponent<
    ITaskAttachmentsProps,
    ITaskAttachmentsState
  >({
    props,
    initialState: {
      selectedAttachmentIndex: 0,
      showAttachmentModal: false,
    },
  });

  const {
    attachments,
    editable,
    users,
    // conversationId,
    // conversationToken,
    onDeleteAttachment,
    // onFileUploaded,
  } = props;
  const { showAttachmentModal, selectedAttachmentIndex } = state;
  return (
    <>
      {attachments && attachments.length > 0 ? (
        <>
          <span
            style={{
              display: 'inline-block',
              fontWeight: 'bold',
              fontSize: '1rem',
              paddingInlineStart: '0.75rem',
              margin: '0.5rem 0',
            }}
          >
            {i18n.t('attachments', { ns: 'taskManager' }) as string}:
          </span>
          <TaskAttachmentsList>
            {[...attachments]
              .sort((a, b) => {
                return (
                  (b.document.uploadDate as number) -
                  (a.document.uploadDate as number)
                );
              })
              .map((attachment: ITaskDocumentView, index: number) => (
                <TaskAttachmentsItem
                  key={attachment.id}
                  attachment={attachment}
                  editable={editable}
                  users={users}
                  onDeleteAttachment={(id: number): void => {
                    onDeleteAttachment(id);
                  }}
                  onSelect={(): void => {
                    setState({
                      showAttachmentModal: true,
                      selectedAttachmentIndex: index,
                    });
                  }}
                />
              ))}
          </TaskAttachmentsList>
          <TaskAttachmentsModal
            isActive={showAttachmentModal}
            attachments={attachments}
            selectedIndex={selectedAttachmentIndex}
            users={users}
            onIndexChanged={(index: number): void => {
              setState({
                selectedAttachmentIndex: index,
              });
            }}
            onClose={(): void => {
              setState({
                showAttachmentModal: false,
              });
            }}
            editableToken={editable}
          />
        </>
      ) : null}
    </>
  );
};
